var COLOR_GRADIENTS = new Map([['white', ['rgba(254, 254, 254, 0.25)', 'rgba(254, 254, 254, 1.0)', 'rgba(254, 254, 254, 1.0)']], ['gray', ['#707474', // dark gray
'#CCCFCF', // light gray
'#CCCFCF', // light gray
'rgba(255,255,255, 0.9)' // white and show some background
]], ['light-gray', ['#CCCFCF', // light gray
'#F8F8F8', // lighter gray
'#F8F8F8', // lighter gray
'rgba(255,255,255, 1.0)' // white
]], ['green', ['rgba(23,194,2, 0.07)', // Background
'#C7F0C6', // slice 1
'#9BD999', // Slice 2
'#78C571', // etc
'rgba(23,194,2, 0.07)']]]);
var DEFAULT_COLOR = 'green';

var getColorGradient = function getColorGradient(color) {
  var colorKey = color || DEFAULT_COLOR;
  return COLOR_GRADIENTS.get(colorKey);
};

var getNumColors = function getNumColors(color) {
  var colorKey = color || DEFAULT_COLOR;
  return COLOR_GRADIENTS.get(colorKey).length;
};

export { getColorGradient, getNumColors };